import type { TelemetrySnapshot } from "../types/telemetry";

export const telemetrySnapshot: TelemetrySnapshot = {
  updatedAt: "18分前",
  phenomena: [
    {
      kind: "quake",
      title: "地震",
      message: "今日の地震は少なめです。",
      stats: [
        { label: "日本", value: "2件" },
        { label: "フィリピン", value: "14件" },
        { label: "チリ", value: "9件" },
        { label: "過去24時間 合計", value: "38件" },
      ],
      detail: "太平洋のまわりで小さな揺れが続いています。",
      help: "小さな地震も表示しています。毎日世界中で数百回発生しています。",
      source: "無料API候補: USGS Earthquake GeoJSON。認証なし。",
    },
    {
      kind: "cloud",
      title: "雲",
      message: "フィリピンの東で大きな雨雲が育っています。",
      stats: [
        { label: "地球の雲", value: "68%" },
        { label: "更新", value: "18分前" },
      ],
      detail: "赤道の近くに白く厚い雲の帯が見えます。",
      help: "気象衛星から取得した最新画像を表示する想定です。",
      source: "無料API候補: NASA GIBS WMTS。衛星画像タイル。",
    },
    {
      kind: "iss",
      title: "ISS",
      message: "ISSは現在インド洋の上を飛んでいます。",
      stats: [
        { label: "速度", value: "27,600km/h" },
        { label: "日本上空まで", value: "あと17分" },
      ],
      detail: "黄色い線がISSの通り道です。",
      help: "ISSは約90分で地球を1周します。",
      source: "無料API候補: Where the ISS at?。認証なし、目安1秒1回。",
    },
    {
      kind: "aurora",
      title: "オーロラ",
      message: "今日は北極の空が光りやすい日です。",
      stats: [
        { label: "見えやすさ", value: "★★★★☆" },
        { label: "強さ", value: "やや強い" },
      ],
      detail: "北のほうに緑の光の輪を重ねています。",
      help: "太陽から飛んできた粒子が地球の磁場とぶつかることで発生します。",
      source: "無料API候補: NOAA SWPC JSON。太陽と磁場の情報。",
    },
    {
      kind: "volcano",
      title: "火山",
      message: "インドネシア周辺の火山を見ています。",
      stats: [
        { label: "注目", value: "3か所" },
        { label: "変化", value: "小さめ" },
      ],
      detail: "赤道近くの島々に、火山の印を置いています。",
      help: "火山は噴火だけでなく、煙や熱の変化も見ます。",
      source: "無料API候補: NASA EONET。火山イベントを取得。",
    },
    {
      kind: "fire",
      title: "火災",
      message: "スマトラ島付近に熱い点があります。",
      stats: [
        { label: "見えている点", value: "5つ" },
        { label: "広がり", value: "小さめ" },
      ],
      detail: "風で煙が流れる可能性があります。",
      help: "衛星は地上の熱い場所を見つけられます。",
      source: "無料API候補: NASA FIRMS。無料キーで火災地点を取得。",
    },
    {
      kind: "typhoon",
      title: "台風の芽",
      message: "太平洋で雲が渦を作りはじめています。",
      stats: [
        { label: "場所", value: "日本の南東" },
        { label: "育ち方", value: "ゆっくり" },
      ],
      detail: "まだ台風ではなく、まとまり始めた雲です。",
      help: "海の上の大きな雲の渦が台風に育つことがあります。",
      source: "無料API候補: NASA EONET severeStorms と NASA GIBS。",
    },
    {
      kind: "ocean",
      title: "海",
      message: "黒潮の近くを生き物が移動しています。",
      stats: [
        { label: "黒潮", value: "日本の南" },
        { label: "海の動き", value: "強め" },
      ],
      detail: "暖かい海の流れに沿って、マグロやウミガメの線を重ねています。",
      help: "海の流れは天気や生き物の移動にも関係します。",
      source: "無料API候補: Open-Meteo Marine。海流と海面温度。",
    },
    {
      kind: "moon",
      title: "月",
      message: "月は地球の奥側へ回り込んでいます。",
      stats: [
        { label: "見え方", value: "細め" },
        { label: "距離", value: "約38万km" },
      ],
      detail: "画面では本物の距離を縮めて、方向がわかるように置いています。",
      help: "月は約1か月で地球のまわりを1周します。",
      source: "無料候補: アプリ内計算。後で天体計算ライブラリで高精度化。",
    },
  ],
  globeObservations: [
    {
      title: "雨雲",
      note: "フィリピン東で発達中",
      lat: 13,
      lon: 142,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "ISS",
      note: "17分後に日本へ",
      attachment: "iss",
      tone: "amber",
    },
    {
      title: "地震",
      note: "チリ沖で小さな揺れ",
      lat: -31,
      lon: -72,
      attachment: "geo",
      tone: "rose",
    },
    {
      title: "火山",
      note: "インドネシア周辺",
      lat: -7,
      lon: 110,
      attachment: "geo",
      tone: "amber",
    },
    {
      title: "火災",
      note: "スマトラ島付近",
      lat: -4,
      lon: 102,
      attachment: "geo",
      tone: "rose",
    },
    {
      title: "台風の芽",
      note: "太平洋で渦",
      lat: 13,
      lon: 136,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "オーロラ",
      note: "北の空が光りやすい",
      lat: 68,
      lon: 145,
      attachment: "geo",
      tone: "green",
    },
    {
      title: "海の熱",
      note: "黒潮まわりが暖かい",
      lat: 29,
      lon: 137,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "海流",
      note: "日本の南を東へ",
      lat: 32,
      lon: 146,
      attachment: "geo",
      tone: "green",
    },
    {
      title: "雨雲",
      note: "インド洋でまとまり",
      lat: -5,
      lon: 86,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "地震",
      note: "アラスカ沖で小さな揺れ",
      lat: 53,
      lon: -156,
      attachment: "geo",
      tone: "rose",
    },
    {
      title: "火災",
      note: "オーストラリア北部",
      lat: -16,
      lon: 133,
      attachment: "geo",
      tone: "rose",
    },
    {
      title: "海の熱",
      note: "アラビア海が暖かい",
      lat: 18,
      lon: 62,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "雨雲",
      note: "インド西で広がる",
      lat: 16,
      lon: 72,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "地震",
      note: "トルコ東部で小さな揺れ",
      lat: 39,
      lon: 42,
      attachment: "geo",
      tone: "rose",
    },
    {
      title: "火災",
      note: "東アフリカに熱い点",
      lat: 2,
      lon: 36,
      attachment: "geo",
      tone: "rose",
    },
    {
      title: "雨雲",
      note: "コンゴ盆地で発達",
      lat: -1,
      lon: 22,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "火災",
      note: "地中海沿岸を確認",
      lat: 38,
      lon: 16,
      attachment: "geo",
      tone: "rose",
    },
    {
      title: "オーロラ",
      note: "北欧の空も注目",
      lat: 67,
      lon: 23,
      attachment: "geo",
      tone: "green",
    },
    {
      title: "雨雲",
      note: "北大西洋で帯状",
      lat: 47,
      lon: -33,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "海流",
      note: "メキシコ湾から北へ",
      lat: 33,
      lon: -72,
      attachment: "geo",
      tone: "green",
    },
    {
      title: "火災",
      note: "北米西部に熱い点",
      lat: 42,
      lon: -121,
      attachment: "geo",
      tone: "rose",
    },
    {
      title: "台風の芽",
      note: "カリブ海で雲が回る",
      lat: 17,
      lon: -78,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "雨雲",
      note: "アマゾン上空で発達",
      lat: -4,
      lon: -62,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "海の熱",
      note: "南大西洋に暖かい帯",
      lat: -28,
      lon: -18,
      attachment: "geo",
      tone: "cyan",
    },
    {
      title: "地震",
      note: "ニュージーランド沖",
      lat: -42,
      lon: 174,
      attachment: "geo",
      tone: "rose",
    },
    {
      title: "雨雲",
      note: "南太平洋でまとまり",
      lat: -18,
      lon: -160,
      attachment: "geo",
      tone: "cyan",
    },
  ],
  animalTracks: [
    {
      id: "bluefin-tuna",
      name: "クロマグロ",
      note: "黒潮から太平洋へ",
      color: 0x62f3ff,
      speed: 0.045,
      path: [
        { lat: 34, lon: 141 },
        { lat: 31, lon: 153 },
        { lat: 27, lon: 166 },
        { lat: 25, lon: -176 },
        { lat: 29, lon: -158 },
      ],
    },
    {
      id: "sea-turtle",
      name: "ウミガメ",
      note: "南の海を移動中",
      color: 0x8dffb2,
      speed: 0.032,
      path: [
        { lat: 4, lon: 124 },
        { lat: 9, lon: 130 },
        { lat: 15, lon: 136 },
        { lat: 22, lon: 142 },
        { lat: 28, lon: 146 },
      ],
    },
    {
      id: "humpback-whale",
      name: "ザトウクジラ",
      note: "北の海から南へ",
      color: 0xd3b8ff,
      speed: 0.026,
      path: [
        { lat: 56, lon: -150 },
        { lat: 46, lon: -148 },
        { lat: 34, lon: -151 },
        { lat: 24, lon: -157 },
        { lat: 20, lon: -160 },
      ],
    },
    {
      id: "migratory-bird",
      name: "渡り鳥",
      note: "東アジアを南へ",
      color: 0xffe28a,
      speed: 0.058,
      path: [
        { lat: 51, lon: 130 },
        { lat: 44, lon: 136 },
        { lat: 36, lon: 140 },
        { lat: 27, lon: 128 },
        { lat: 17, lon: 111 },
      ],
    },
  ],
  globeFeed: [
    "地震: 日本2件 / フィリピン14件 / チリ9件 / 過去24時間で38件",
    "雲: フィリピンの東で大きな雨雲が育っています / 地球の雲68%",
    "ISS: 現在インド洋の上を飛行中 / 速度27,600km/h / 日本上空まであと17分",
    "オーロラ: 北極の空が光りやすい日です / 見えやすさ★★★★☆",
    "火山: インドネシア周辺に注目 / 小さな変化を観測中",
    "火災: スマトラ島付近に熱い点 / 風向きに注意",
    "台風の芽: 太平洋で雲が渦を作りはじめています",
    "海: 黒潮の近くをクロマグロとウミガメが移動中",
    "海の熱: 日本の南で暖かい海が広がっています",
    "火山: インドネシア周辺で小さな変化を観測中",
    "火災: スマトラ島付近とオーストラリア北部に熱い点",
    "インド洋: アラビア海が暖かく、インド西で雲が広がっています",
    "アフリカ: コンゴ盆地で雨雲、東アフリカで熱い点を表示中",
    "ヨーロッパ: 北欧はオーロラ、地中海沿岸は火災の印",
    "大西洋: 北大西洋に雲の帯、南大西洋に暖かい海",
    "アメリカ: カリブ海の雲、北米西部の火災、アマゾンの雨雲",
    "南太平洋: ニュージーランド沖の地震とまとまった雨雲",
    "月: 現在の空の方向を簡易計算で表示しています",
    "星: 遠くの星は背景として固定表示、月は地球との位置で表示",
    "生き物: クロマグロが黒潮から太平洋へ移動中",
    "生き物: ウミガメと渡り鳥の移動ルートを表示中",
  ],
  liveReport: [
    "現在フィリピン東方で巨大な積乱雲が発達しています。",
    "チリ沖では小さな地震が続いています。",
    "ISSは17分後に日本上空を通過します。",
    "北極ではオーロラ活動が活発です。",
    "黒潮の近くではクロマグロとウミガメの移動線を表示しています。",
    "インドネシア周辺では火山、スマトラ島付近では火災の印を置いています。",
    "インド洋、アフリカ、大西洋、アメリカ側にも観測メモを散らしています。",
  ],
};
